/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EarnSocialPostBody
 */
export interface EarnSocialPostBody {
    /**
     * 
     * @type {string}
     * @memberof EarnSocialPostBody
     */
    objectiveTemplateId: string;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialPostBody
     */
    postUrl: string;
    /**
     * 
     * @type {string}
     * @memberof EarnSocialPostBody
     */
    platform: string;
}

/**
 * Check if a given object implements the EarnSocialPostBody interface.
 */
export function instanceOfEarnSocialPostBody(value: object): value is EarnSocialPostBody {
    if (!('objectiveTemplateId' in value) || value['objectiveTemplateId'] === undefined) return false;
    if (!('postUrl' in value) || value['postUrl'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function EarnSocialPostBodyFromJSON(json: any): EarnSocialPostBody {
    return EarnSocialPostBodyFromJSONTyped(json, false);
}

export function EarnSocialPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarnSocialPostBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'],
        'postUrl': json['postUrl'],
        'platform': json['platform'],
    };
}

export function EarnSocialPostBodyToJSON(json: any): EarnSocialPostBody {
    return EarnSocialPostBodyToJSONTyped(json, false);
}

export function EarnSocialPostBodyToJSONTyped(value?: EarnSocialPostBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'postUrl': value['postUrl'],
        'platform': value['platform'],
    };
}

